<app-alert-modal
  dynamicClass="update-email-modal"
  (confirmed)="verifyOtp()"
  #updateEmailRef
  [confirmBtnLabel]="labels.verify"
  [cancelBtnLabel]="''"
  [secondaryBtnLabel]="!isResend ? labels.resendCode : ''"
  [closeModalOnSuccess]="false"
  [modalOptions]="{ class: 'modal-sm' }"
  [headerLabel]="labels.verifyOTP"
  (canceled)="handleCancel()"
  [disableConfirmButton]="isVerificationInProgress || newOtp?.length !== 6"
  (secondaryConfirmed)="sendOtp()"
>
  <div class="modal-verification">
    <div class="d-flex mt-2">
      <div class="modal-verify mt-0">
        <p>
          {{ labels.enterVerificationCode }}
          <b>{{ loggedInUser?.email }}</b>
        </p>
        <div class="modal-verify-form">
          <div class="modal-verify-input">
            <ng-otp-input
              #ngOtpInput
              [config]="otpConfig"
              (onInputChange)="onNewOtpChange($event)"
              (keyup.enter)="clickEnter()"
            ></ng-otp-input>
          </div>
        </div>
        <p *ngIf="isResend" class="mt-3 mb-0">
          {{ labels.otpNotReceived }}
          {{ counter | formatTime }}
        </p>
      </div>
    </div>
  </div>
</app-alert-modal>
